//don't add any newlines between the tick marks, otw you'll get a blank item in the bucket of texts
const letterText_en = `A
B
C
D
E
F
G
H
I
J
K
L
M
N
O
P
Q
R
S
T
U
V
W
X
Y
Z`;
export default letterText_en;
